import makeAnimated from "react-select/animated";
import { AsyncPaginate, AsyncPaginateProps } from "react-select-async-paginate";
import { CreatableAdditionalProps } from "react-select/dist/declarations/src/useCreatable";
import Select, { GroupBase, Props } from "react-select";
import AsyncSelect, { AsyncProps } from "react-select/async";

import { THEME } from "@/styles/theme";

export type Additional = { page: number };

export type SelectComponentProps = (
	| Props
	| AsyncProps<unknown, boolean, GroupBase<unknown>>
	| CreatableAdditionalProps<unknown, GroupBase<unknown>>
	| AsyncPaginateSelectProps
) & {
	isAsync?: boolean;
	isAsyncPaginate?: boolean;
};

export type AsyncSelectProps = AsyncProps<unknown, boolean, GroupBase<unknown>>;

export type AsyncPaginateSelectProps = AsyncPaginateProps<
	unknown,
	GroupBase<unknown>,
	Additional,
	boolean
>;

const animatedComponents = makeAnimated();

export function SelectComponent({ isAsync, isAsyncPaginate, ...props }: SelectComponentProps) {
	const defaultComponents = {
		IndicatorSeparator: null,
	};

	const defaultProps: Props = {
		components: defaultComponents,
		theme: (theme) => ({
			...theme,
			colors: {
				...theme.colors,
				primary: THEME.COLORS.PRIMARY,
				primary25: THEME.COLORS.PRIMARY25,
			},
		}),
		styles: {
			menu: (base) => ({ ...base, zIndex: 90 }),
			control: (base) => ({
				...base,
				minHeight: "30px",
				padding: "0px",
				borderColor: "#919191",
			}),
			valueContainer: (base) => ({
				...base,
				padding: "0px 4px",
			}),
			indicatorsContainer: (base) => ({
				...base,
				height: "30px",
			}),
			dropdownIndicator: (base) => ({
				...base,
				color: "#919191",
			}),
		},
		isOptionDisabled: (option: any) => option.disabled ?? false,
		noOptionsMessage: () => "Nenhum resultado encontrado",
	};

	if (isAsync) {
		return (
			<AsyncSelect
				loadingMessage={() => "Carregando..."}
				{...defaultProps}
				{...(props as AsyncSelectProps)}
			/>
		);
	} else if (isAsyncPaginate) {
		return (
			<AsyncPaginate
				loadingMessage={() => "Carregando..."}
				{...defaultProps}
				{...(props as AsyncPaginateSelectProps)}
			/>
		);
	}

	return (
		<Select
			components={{
				...defaultComponents,
				...animatedComponents,
			}}
			{...defaultProps}
			{...props}
		/>
	);
}
